export default "__VITE_ASSET__DtSf3PBC__"